/*
 * @Author: luting
 * @Date: 2022-04-09 11:23:21
 * @lastEditors: luting
 * @LastEditTime: 2023-08-02 16:53:11
 */
import React, { useCallback, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import messages from '../messages';
import { disk } from 'root/store/disk/actions';
import { Table, InputNumber, message, Tooltip } from 'sup-ui';
import { getUnallocatedBlock, judgeTotalSize } from 'root/utils/getUnallocatedBlock';
import { availableDiskType } from 'root/pages/DiskConfig/diskTypes';
import { getRealUseColumns } from './getRealUseColumns';
import Icon from 'root/components/Icon';
import warningIcon from 'root/assets/images/icon_warn.svg';

import style from './index.less';

interface IConfirmDisk {
  id: number;
  totalSize: number;
  vgPath: string;
  vgName: string;
  freeSize: string | number;
  dataSource: availableDiskType[];
  columnLists: string[];
  updataDiskSize: boolean;
  showPlus?: boolean;
  setAddDiskVisible?: any;
  lessen?: boolean;
  setShowTip?: any;
  setMinLimt?: any;
}

const ConfirmDiskBody: React.FC<IConfirmDisk> = (props) => {
  const intl = useIntl();

  const dispatch = useDispatch();
  const {
    dataSource,
    lessen = true, // 允许减少,默认是允许减少的
    setShowTip,
    setMinLimt,
    columnLists,
    totalSize,
    id,
    updataDiskSize,
    freeSize,
    showPlus,
    setAddDiskVisible,
    vgName,
  } = props;
  const diffDataSource = getUnallocatedBlock(dataSource, totalSize); // 计算出未分配的容量用于容量块
  // const [childWidth,setChildWidth] = useState<number[]>([]); // 容量块内文字的宽度
  const { record: recordData, confirmDiskData } = useSelector((state: reducerStates) => state.disk);
  const { serverStatus } = useSelector((state: reducerStates) => state.common);
  const [tipList, setTipList] = useState<number[]>([]);
  const [lessentList, setLessentList] = useState<number[]>([]);

  const formatter = (value: number) => {
    return String(value).replace(/\./g, '') && value.toString().replace(/\D/g, '');
  };

  const columns = [
    {
      title: intl.formatMessage(messages.mountPoint),
      dataIndex: 'mountPoint',
      key: 'mountPoint',
      onCell: () => {
        return {
          style: {
            maxWidth: 500,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            cursor: 'pointer',
          },
        };
      },
      render: (text: string, record: any) =>
        record.hasOther ? (
          <Tooltip title={record.allName}>
            <span>{text}</span>
          </Tooltip>
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: intl.formatMessage(messages.capacity),
      dataIndex: 'size',
      key: 'size',
      align: 'left',
      render: (text: string, record: any, index: number) =>
        updataDiskSize && record.suposPath ? (
          <div>
            <InputNumber
              value={text || 0}
              style={{ width: 100 }}
              formatter={formatter}
              onBlur={() => judgeBlur(record.size, index, record.initVal)}
              onChange={(e: number) => inputChange(e, record.size, index)}
              className={tipList.includes(index) || lessentList.includes(index) ? style.inputError : ''}
            />
            <span className={style.unit}>GB</span>
            {!['3.5', 'init'].includes(serverStatus) && (
              <span style={{ paddingLeft: 10 }} className={tipList.includes(index) ? style.tip : ''}>
                ≥{record.initVal}
                {tipList.includes(index) ? (
                  <span className={style.tipText}>
                    {intl.formatMessage(messages.tipText, { size: `${record.minSize}` })}
                  </span>
                ) : null}
              </span>
            )}
          </div>
        ) : (
          <div className={style.size}>
            <i> {text}</i>
            <span> GB</span>
          </div>
        ),
    },
    {
      title: intl.formatMessage(messages.used),
      dataIndex: 'usedSize',
      ket: 'usedSize',
      render: (text: string) => changeUnit(Number(text)),
    },
    {
      title: intl.formatMessage(messages.operate),
      dataIndex: 'operate',
      ket: 'operate',
      align: 'center',
      render: (text: string, record: any) => (record.suposPath && freeSize > 0 ? getPartitionNode() : '-'),
    },
  ];

  // 当有设置的值小于最小值的时候 更新状态
  useEffect(() => {
    if (!setMinLimt) return;
    tipList.length ? setMinLimt(true) : setMinLimt(false);
  }, [tipList]);

  // 当有有输入的小于原来的的值 更新状态
  useEffect(() => {
    if (!setShowTip) return;
    lessentList.length ? setShowTip(true) : setShowTip(false);
  }, [lessentList]);

  // 已使用列后端给的数据单位时GB,如果小于1时要将单位更改为MB
  const changeUnit = (text: number) => {
    let size = text;
    let unit = 'GB';
    if (text < 1) {
      size = parseFloat((text * 1024).toFixed(2));
      unit = 'MB';
    }
    return (
      <div className={style.size}>
        <i>{size}</i>
        <span style={{ paddingLeft: 6 }}>{unit}</span>
      </div>
    );
  };

  // 获取扩展文字
  const getPartitionNode = () => {
    return (
      <span style={{ color: '#2280FA', cursor: 'pointer' }} onClick={operateEvent}>
        {intl.formatMessage(messages.extension)}
      </span>
    );
  };

  // 失去焦点时判断可用容量是不是大于总容量
  const judgeBlur = (size: number, index: number, initVal: number) => {
    // 如果当前这一项 设置的值小于初始值并且数组中没有这一项
    if (!['3.5', 'init'].includes(serverStatus)) {
      if (size < initVal && !tipList.includes(index)) {
        setTipList([...tipList, index]);
      }
      // 当前值大于等于初始值 删除这一项
      if (size >= initVal && tipList.indexOf(index)! > -1) {
        const list = JSON.parse(JSON.stringify(tipList));
        list.splice(list.indexOf(index), 1);
        setTipList([...list]);
      }
    }

    const { difference, result } = judgeTotalSize(recordData || confirmDiskData[0]);

    if (result) {
      message.error(intl.formatMessage(messages.judgeTotalSize));
    }

    // 当可分配空间出现负值的时候,让输入的值自动减去超过的部分
    if (difference < 0) {
      // 有record说明打开了ChangeDisk的modal
      if (recordData) {
        dispatch(
          disk.updateRecord({
            size: size + difference,
            index,
          }),
        );
      } else {
        dispatch(
          disk.updateDiskData({
            id,
            size: size + difference,
            index,
          }),
        );
      }
      inputChange(size + difference, size, index);
    }
  };

  // inputNumber的change事件
  const inputChange = (e: number, size: number, index: number) => {
    // 有record说明打开了ChangeDisk的modal
    if (recordData) {
      // number 是初始数据  e时新数据
      const number: any = confirmDiskData.find((item) => item.id === recordData.id)?.mountPoints[index].size;

      // 当输入的值小于最小值的时候,添加进列表
      if (number > e && !lessen && !lessentList.includes(index) && serverStatus === '3.5') {
        setLessentList([...lessentList, index]);
      }
      // 当前值大于等于初始值 删除这一项
      if (number <= e && lessentList.indexOf(index)! > -1) {
        const list = JSON.parse(JSON.stringify(lessentList));
        list.splice(list.indexOf(index), 1);
        setLessentList([...list]);
      }

      // 以上时允不允许减少
      dispatch(
        disk.updateRecord({
          size: e,
          index,
        }),
      );
    } else {
      // 全新更改容量时,直接操作donfirmDiskData
      dispatch(
        disk.updateDiskData({
          id,
          size: e,
          index,
        }),
      );
    }
  };

  // 扩展分区事件
  const operateEvent = () => {
    dispatch(
      disk.getDiskId({
        id,
      }),
    );
    dispatch(
      disk.filterRecord({
        id,
      }),
    );
    dispatch(disk.getVisible({ visible: true }));
  };

  const childRef = useCallback((node) => {
    if (node !== null) {
      // const number: any = node.getBoundingClientRect().width;
      // setChildWidth((pre) => {
      //   return pre.concat([number]);
      // });
    }
  }, []);

  const getColor = (type: number) => {
    switch (type) {
      case 0: // 不是supos的目录
        return '#fff';
      case 1: // 是supos的目录
        return '#d8e9fb';
      default: // 未分配
        return '#eceff1';
    }
  };

  const addDisk = () => {
    setAddDiskVisible(true);
    dispatch(
      disk.filterRecord({
        id,
      }),
    );
  };

  return (
    <div className={style.confirmDiskContainer}>
      <div className={style.confirmDiskHead}>
        <div>{intl.formatMessage(messages.node) + ':' + vgName}</div>
        <div className={style.confirmDiskPlus}>
          <p style={{ marginRight: 14 }}>{totalSize} GB</p>
          {showPlus && <Icon onClick={addDisk} className={style.plusIcon} type="plus28" />}
        </div>
      </div>
      <div className={style.confirmDiskCard}>
        {diffDataSource.map((item) => (
          <div
            className={style.confirmDiskProportion}
            key={item.mountPoint}
            style={{
              minWidth: 70,
              width: Number(item.size) > totalSize ? ' 100%' : `${(Number(item.size) / totalSize) * 100}%`,
              border: item.size > 0 ? '1px solid rgba(219, 226, 233, 1)' : 'none',
              backgroundColor: getColor(item.suposPath),
            }}
            title={
              item.mountPoint
                ? `${item.mountPoint},${item.availableSize} GB 可用，共 ${item.size} GB`
                : `${intl.formatMessage(messages.undistributed)} ,${item.size} GB`
            }
          >
            {item.size > 0 ? (
              <div
                // style={{
                //   visibility: childWidth[index] > 60 ? 'visible' : 'visible',
                // }}
                className={style.numberBlock}
                ref={childRef}
              >
                {item.mountPoint || intl.formatMessage(messages.undistributed)}
                <br />
                {item.mountPoint ? (
                  <span className={style.number}>
                    {item.availableSize} GB 可用，共 {item.size} GB
                  </span>
                ) : (
                  <span className={style.number}>{item.size} GB</span>
                )}
                {item.status === 'WARNING' && (
                  <img src={warningIcon} className={style.warnIcon} title={intl.formatMessage(messages.diskSpaceTip)} />
                )}
              </div>
            ) : (
              ''
            )}
          </div>
        ))}
      </div>
      <Table
        rowKey="mountPoint"
        columns={getRealUseColumns(columnLists, columns)}
        dataSource={dataSource}
        pagination={false}
        rowClassName={(record: any) => {
          if (record.suposPath === 1) {
            return style.suposRow;
          }
          return style.otherRow;
        }}
      />
    </div>
  );
};

export default ConfirmDiskBody;
